import Graphic from '@arcgis/core/Graphic'

import { getGraphicShapeKey } from './graphicShapeKey'

type GetPopupFeatureGraphicForShapeKeyArgs = {
  shapeKey: string
  clickedGraphic: Graphic | null | undefined
  graphicsForShapeKey: Graphic[]
}

/** Point pin when present; otherwise the polygon fill used for map selection. */
export const getInteractiveGraphicFromShapeGraphics = (
  graphicsForShapeKey: Graphic[]
): Graphic | undefined =>
  graphicsForShapeKey.find((graphic) => graphic.geometry?.type === 'point') ??
  graphicsForShapeKey.find((graphic) => graphic.geometry?.type === 'polygon')

/**
 * Resolves which graphic to pass to ArcGIS openPopup for a shape key.
 * Polygon-only shapes (no centroid pin) must use the polygon graphic so clicks on the fill work.
 */
export const getPopupFeatureGraphicForShapeKey = ({
  shapeKey,
  clickedGraphic,
  graphicsForShapeKey,
}: GetPopupFeatureGraphicForShapeKeyArgs): Graphic | null => {
  if (clickedGraphic && getGraphicShapeKey(clickedGraphic) === shapeKey) {
    return clickedGraphic
  }

  return getInteractiveGraphicFromShapeGraphics(graphicsForShapeKey) ?? null
}
